// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.35.0
// source: common/account.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire'

import {
  MarginMethod,
  marginMethodFromJSON,
  marginMethodToJSON,
  MarginScope,
  marginScopeFromJSON,
  marginScopeToJSON,
  TradeVenue,
  tradeVenueFromJSON,
  tradeVenueToJSON,
} from './types'

export const protobufPackage = 'common.account'

/** Account status enum */
export enum AccountStatus {
  ACCOUNT_STATUS_UNSPECIFIED = 0,
  ACCOUNT_STATUS_ACTIVE = 1,
  ACCOUNT_STATUS_INACTIVE = 2,
  ACCOUNT_STATUS_SUSPENDED = 3,
  ACCOUNT_STATUS_PENDING_AUTH = 4,
  ACCOUNT_STATUS_AUTH_FAILED = 5,
  ACCOUNT_STATUS_CREATING = 6,
  /**
   * ACCOUNT_STATUS_FROZEN - Billing freeze: the owner's tier no longer permits this account's trade
   * venue (per-account venue downgrade). Socket released, trading blocked;
   * positions remain on the exchange. Distinct from operator SUSPENDED.
   */
  ACCOUNT_STATUS_FROZEN = 7,
  UNRECOGNIZED = -1,
}

export function accountStatusFromJSON(object: any): AccountStatus {
  switch (object) {
    case 0:
    case 'ACCOUNT_STATUS_UNSPECIFIED':
      return AccountStatus.ACCOUNT_STATUS_UNSPECIFIED
    case 1:
    case 'ACCOUNT_STATUS_ACTIVE':
      return AccountStatus.ACCOUNT_STATUS_ACTIVE
    case 2:
    case 'ACCOUNT_STATUS_INACTIVE':
      return AccountStatus.ACCOUNT_STATUS_INACTIVE
    case 3:
    case 'ACCOUNT_STATUS_SUSPENDED':
      return AccountStatus.ACCOUNT_STATUS_SUSPENDED
    case 4:
    case 'ACCOUNT_STATUS_PENDING_AUTH':
      return AccountStatus.ACCOUNT_STATUS_PENDING_AUTH
    case 5:
    case 'ACCOUNT_STATUS_AUTH_FAILED':
      return AccountStatus.ACCOUNT_STATUS_AUTH_FAILED
    case 6:
    case 'ACCOUNT_STATUS_CREATING':
      return AccountStatus.ACCOUNT_STATUS_CREATING
    case 7:
    case 'ACCOUNT_STATUS_FROZEN':
      return AccountStatus.ACCOUNT_STATUS_FROZEN
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AccountStatus.UNRECOGNIZED
  }
}

export function accountStatusToJSON(object: AccountStatus): string {
  switch (object) {
    case AccountStatus.ACCOUNT_STATUS_UNSPECIFIED:
      return 'ACCOUNT_STATUS_UNSPECIFIED'
    case AccountStatus.ACCOUNT_STATUS_ACTIVE:
      return 'ACCOUNT_STATUS_ACTIVE'
    case AccountStatus.ACCOUNT_STATUS_INACTIVE:
      return 'ACCOUNT_STATUS_INACTIVE'
    case AccountStatus.ACCOUNT_STATUS_SUSPENDED:
      return 'ACCOUNT_STATUS_SUSPENDED'
    case AccountStatus.ACCOUNT_STATUS_PENDING_AUTH:
      return 'ACCOUNT_STATUS_PENDING_AUTH'
    case AccountStatus.ACCOUNT_STATUS_AUTH_FAILED:
      return 'ACCOUNT_STATUS_AUTH_FAILED'
    case AccountStatus.ACCOUNT_STATUS_CREATING:
      return 'ACCOUNT_STATUS_CREATING'
    case AccountStatus.ACCOUNT_STATUS_FROZEN:
      return 'ACCOUNT_STATUS_FROZEN'
    case AccountStatus.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Role a user holds on an account via their USER#/LINK# row. Mirrors the
 * DynamoDB `Permission` enum (shared/dynamodb/src/types.rs).
 */
export enum AccountRole {
  ACCOUNT_ROLE_UNSPECIFIED = 0,
  ACCOUNT_ROLE_READ_ONLY = 1,
  ACCOUNT_ROLE_READ_WRITE = 2,
  /** ACCOUNT_ROLE_ADMIN - DEPRECATED — superseded by OWNER; not assigned to new links */
  ACCOUNT_ROLE_ADMIN = 3,
  /** ACCOUNT_ROLE_OWNER - top role; exactly one per account; transferable */
  ACCOUNT_ROLE_OWNER = 4,
  UNRECOGNIZED = -1,
}

export function accountRoleFromJSON(object: any): AccountRole {
  switch (object) {
    case 0:
    case 'ACCOUNT_ROLE_UNSPECIFIED':
      return AccountRole.ACCOUNT_ROLE_UNSPECIFIED
    case 1:
    case 'ACCOUNT_ROLE_READ_ONLY':
      return AccountRole.ACCOUNT_ROLE_READ_ONLY
    case 2:
    case 'ACCOUNT_ROLE_READ_WRITE':
      return AccountRole.ACCOUNT_ROLE_READ_WRITE
    case 3:
    case 'ACCOUNT_ROLE_ADMIN':
      return AccountRole.ACCOUNT_ROLE_ADMIN
    case 4:
    case 'ACCOUNT_ROLE_OWNER':
      return AccountRole.ACCOUNT_ROLE_OWNER
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AccountRole.UNRECOGNIZED
  }
}

export function accountRoleToJSON(object: AccountRole): string {
  switch (object) {
    case AccountRole.ACCOUNT_ROLE_UNSPECIFIED:
      return 'ACCOUNT_ROLE_UNSPECIFIED'
    case AccountRole.ACCOUNT_ROLE_READ_ONLY:
      return 'ACCOUNT_ROLE_READ_ONLY'
    case AccountRole.ACCOUNT_ROLE_READ_WRITE:
      return 'ACCOUNT_ROLE_READ_WRITE'
    case AccountRole.ACCOUNT_ROLE_ADMIN:
      return 'ACCOUNT_ROLE_ADMIN'
    case AccountRole.ACCOUNT_ROLE_OWNER:
      return 'ACCOUNT_ROLE_OWNER'
    case AccountRole.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * How an account authenticates to its trade venue. Drives venue auth dispatch,
 * the credential-edit gate, and the frontend UI. UNSPECIFIED is treated as
 * API_KEY for backward compatibility with rows written before this field.
 */
export enum AccountAuthMethod {
  ACCOUNT_AUTH_METHOD_UNSPECIFIED = 0,
  /** ACCOUNT_AUTH_METHOD_API_KEY - Stored api_key/api_secret (manual entry + Bybit OAuth broker keys). */
  ACCOUNT_AUTH_METHOD_API_KEY = 1,
  /**
   * ACCOUNT_AUTH_METHOD_APP_USER - App acts on the user's behalf via a stored subject id + the app's own
   * credentials (Deribit Registered Partner Model app_user grant).
   */
  ACCOUNT_AUTH_METHOD_APP_USER = 2,
  /**
   * ACCOUNT_AUTH_METHOD_AGENT_WALLET - Hyperliquid agent (API) wallet. The server-generated agent private key is
   * stored in api_secret; master_address holds the customer's master account.
   * The agent can trade but cannot withdraw/transfer.
   */
  ACCOUNT_AUTH_METHOD_AGENT_WALLET = 3,
  /**
   * ACCOUNT_AUTH_METHOD_SESSION_KEY - Derive (derive.xyz) session key. api_secret holds the server-minted
   * session-key private key; master_address holds the customer's wallet
   * address; derive_subaccount_id holds which subaccount the key trades.
   * The session key can trade (admin scope — no trade-only scope exists on
   * Derive today, see the research doc §4.2); the customer's wallet
   * authorizes it, never reaches the backend.
   */
  ACCOUNT_AUTH_METHOD_SESSION_KEY = 4,
  UNRECOGNIZED = -1,
}

export function accountAuthMethodFromJSON(object: any): AccountAuthMethod {
  switch (object) {
    case 0:
    case 'ACCOUNT_AUTH_METHOD_UNSPECIFIED':
      return AccountAuthMethod.ACCOUNT_AUTH_METHOD_UNSPECIFIED
    case 1:
    case 'ACCOUNT_AUTH_METHOD_API_KEY':
      return AccountAuthMethod.ACCOUNT_AUTH_METHOD_API_KEY
    case 2:
    case 'ACCOUNT_AUTH_METHOD_APP_USER':
      return AccountAuthMethod.ACCOUNT_AUTH_METHOD_APP_USER
    case 3:
    case 'ACCOUNT_AUTH_METHOD_AGENT_WALLET':
      return AccountAuthMethod.ACCOUNT_AUTH_METHOD_AGENT_WALLET
    case 4:
    case 'ACCOUNT_AUTH_METHOD_SESSION_KEY':
      return AccountAuthMethod.ACCOUNT_AUTH_METHOD_SESSION_KEY
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AccountAuthMethod.UNRECOGNIZED
  }
}

export function accountAuthMethodToJSON(object: AccountAuthMethod): string {
  switch (object) {
    case AccountAuthMethod.ACCOUNT_AUTH_METHOD_UNSPECIFIED:
      return 'ACCOUNT_AUTH_METHOD_UNSPECIFIED'
    case AccountAuthMethod.ACCOUNT_AUTH_METHOD_API_KEY:
      return 'ACCOUNT_AUTH_METHOD_API_KEY'
    case AccountAuthMethod.ACCOUNT_AUTH_METHOD_APP_USER:
      return 'ACCOUNT_AUTH_METHOD_APP_USER'
    case AccountAuthMethod.ACCOUNT_AUTH_METHOD_AGENT_WALLET:
      return 'ACCOUNT_AUTH_METHOD_AGENT_WALLET'
    case AccountAuthMethod.ACCOUNT_AUTH_METHOD_SESSION_KEY:
      return 'ACCOUNT_AUTH_METHOD_SESSION_KEY'
    case AccountAuthMethod.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * User entitlement tier. Stored on the DbUser row as the SCREAMING_SNAKE name
 * (e.g. "PLAN_LEVEL_PRO") and joined to the user signed-tuple. UNSPECIFIED is
 * treated as FREE (fail-closed). ENTERPRISE is RESERVED — not built this
 * milestone (seat-based org billing is additive later).
 */
export enum PlanLevel {
  /** PLAN_LEVEL_UNSPECIFIED - treated as FREE */
  PLAN_LEVEL_UNSPECIFIED = 0,
  PLAN_LEVEL_FREE = 1,
  PLAN_LEVEL_PRO = 2,
  /** PLAN_LEVEL_ENTERPRISE - RESERVED — not built */
  PLAN_LEVEL_ENTERPRISE = 3,
  /** PLAN_LEVEL_BASIC - entry paid tier ($199/mo); between FREE and PRO */
  PLAN_LEVEL_BASIC = 4,
  UNRECOGNIZED = -1,
}

export function planLevelFromJSON(object: any): PlanLevel {
  switch (object) {
    case 0:
    case 'PLAN_LEVEL_UNSPECIFIED':
      return PlanLevel.PLAN_LEVEL_UNSPECIFIED
    case 1:
    case 'PLAN_LEVEL_FREE':
      return PlanLevel.PLAN_LEVEL_FREE
    case 2:
    case 'PLAN_LEVEL_PRO':
      return PlanLevel.PLAN_LEVEL_PRO
    case 3:
    case 'PLAN_LEVEL_ENTERPRISE':
      return PlanLevel.PLAN_LEVEL_ENTERPRISE
    case 4:
    case 'PLAN_LEVEL_BASIC':
      return PlanLevel.PLAN_LEVEL_BASIC
    case -1:
    case 'UNRECOGNIZED':
    default:
      return PlanLevel.UNRECOGNIZED
  }
}

export function planLevelToJSON(object: PlanLevel): string {
  switch (object) {
    case PlanLevel.PLAN_LEVEL_UNSPECIFIED:
      return 'PLAN_LEVEL_UNSPECIFIED'
    case PlanLevel.PLAN_LEVEL_FREE:
      return 'PLAN_LEVEL_FREE'
    case PlanLevel.PLAN_LEVEL_PRO:
      return 'PLAN_LEVEL_PRO'
    case PlanLevel.PLAN_LEVEL_ENTERPRISE:
      return 'PLAN_LEVEL_ENTERPRISE'
    case PlanLevel.PLAN_LEVEL_BASIC:
      return 'PLAN_LEVEL_BASIC'
    case PlanLevel.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Stripe billing interval for a Pro subscription. Monthly and yearly are two
 * distinct Stripe price IDs that both map to PLAN_LEVEL_PRO; interval affects
 * price, not entitlements.
 */
export enum BillingInterval {
  BILLING_INTERVAL_UNSPECIFIED = 0,
  BILLING_INTERVAL_MONTHLY = 1,
  BILLING_INTERVAL_YEARLY = 2,
  UNRECOGNIZED = -1,
}

export function billingIntervalFromJSON(object: any): BillingInterval {
  switch (object) {
    case 0:
    case 'BILLING_INTERVAL_UNSPECIFIED':
      return BillingInterval.BILLING_INTERVAL_UNSPECIFIED
    case 1:
    case 'BILLING_INTERVAL_MONTHLY':
      return BillingInterval.BILLING_INTERVAL_MONTHLY
    case 2:
    case 'BILLING_INTERVAL_YEARLY':
      return BillingInterval.BILLING_INTERVAL_YEARLY
    case -1:
    case 'UNRECOGNIZED':
    default:
      return BillingInterval.UNRECOGNIZED
  }
}

export function billingIntervalToJSON(object: BillingInterval): string {
  switch (object) {
    case BillingInterval.BILLING_INTERVAL_UNSPECIFIED:
      return 'BILLING_INTERVAL_UNSPECIFIED'
    case BillingInterval.BILLING_INTERVAL_MONTHLY:
      return 'BILLING_INTERVAL_MONTHLY'
    case BillingInterval.BILLING_INTERVAL_YEARLY:
      return 'BILLING_INTERVAL_YEARLY'
    case BillingInterval.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Category of subscribable stream, used to advertise which live channels a
 * plan unlocks. Mirrors the StreamKind classifier in public-api (subscribe.rs);
 * the MessageSubject -> StreamKind mapping stays server-side.
 */
export enum StreamKind {
  STREAM_KIND_UNSPECIFIED = 0,
  STREAM_KIND_MARKET_DATA = 1,
  STREAM_KIND_ACCOUNT_DATA = 2,
  STREAM_KIND_EXECUTION_ANALYTICS = 3,
  STREAM_KIND_OPTIONS_FLOW = 4,
  STREAM_KIND_CHART_DATA = 5,
  STREAM_KIND_MARKET_SCREENER = 6,
  UNRECOGNIZED = -1,
}

export function streamKindFromJSON(object: any): StreamKind {
  switch (object) {
    case 0:
    case 'STREAM_KIND_UNSPECIFIED':
      return StreamKind.STREAM_KIND_UNSPECIFIED
    case 1:
    case 'STREAM_KIND_MARKET_DATA':
      return StreamKind.STREAM_KIND_MARKET_DATA
    case 2:
    case 'STREAM_KIND_ACCOUNT_DATA':
      return StreamKind.STREAM_KIND_ACCOUNT_DATA
    case 3:
    case 'STREAM_KIND_EXECUTION_ANALYTICS':
      return StreamKind.STREAM_KIND_EXECUTION_ANALYTICS
    case 4:
    case 'STREAM_KIND_OPTIONS_FLOW':
      return StreamKind.STREAM_KIND_OPTIONS_FLOW
    case 5:
    case 'STREAM_KIND_CHART_DATA':
      return StreamKind.STREAM_KIND_CHART_DATA
    case 6:
    case 'STREAM_KIND_MARKET_SCREENER':
      return StreamKind.STREAM_KIND_MARKET_SCREENER
    case -1:
    case 'UNRECOGNIZED':
    default:
      return StreamKind.UNRECOGNIZED
  }
}

export function streamKindToJSON(object: StreamKind): string {
  switch (object) {
    case StreamKind.STREAM_KIND_UNSPECIFIED:
      return 'STREAM_KIND_UNSPECIFIED'
    case StreamKind.STREAM_KIND_MARKET_DATA:
      return 'STREAM_KIND_MARKET_DATA'
    case StreamKind.STREAM_KIND_ACCOUNT_DATA:
      return 'STREAM_KIND_ACCOUNT_DATA'
    case StreamKind.STREAM_KIND_EXECUTION_ANALYTICS:
      return 'STREAM_KIND_EXECUTION_ANALYTICS'
    case StreamKind.STREAM_KIND_OPTIONS_FLOW:
      return 'STREAM_KIND_OPTIONS_FLOW'
    case StreamKind.STREAM_KIND_CHART_DATA:
      return 'STREAM_KIND_CHART_DATA'
    case StreamKind.STREAM_KIND_MARKET_SCREENER:
      return 'STREAM_KIND_MARKET_SCREENER'
    case StreamKind.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Paradigm (paradigm.co) RFQ desk nickname-to-account binding, carried on
 * PublicAccount so the frontend can render the mismatch warning and both
 * remediations without an extra round-trip. See ParadigmAccountInfo and
 * ParadigmLinkAccountResponse in public_api.proto for the wizard's
 * request/response shapes.
 *
 * PARADIGM_BINDING_STATE_UNSPECIFIED == every pre-existing row and every
 * message from an older client — prost decodes an absent field to 0. It
 * means "no data", never "unknown but safe".
 */
export enum ParadigmBindingState {
  /** PARADIGM_BINDING_STATE_UNSPECIFIED - treated as UNVERIFIED */
  PARADIGM_BINDING_STATE_UNSPECIFIED = 0,
  PARADIGM_BINDING_STATE_VERIFIED = 1,
  PARADIGM_BINDING_STATE_UNVERIFIED = 2,
  PARADIGM_BINDING_STATE_MISMATCH = 3,
  UNRECOGNIZED = -1,
}

export function paradigmBindingStateFromJSON(object: any): ParadigmBindingState {
  switch (object) {
    case 0:
    case 'PARADIGM_BINDING_STATE_UNSPECIFIED':
      return ParadigmBindingState.PARADIGM_BINDING_STATE_UNSPECIFIED
    case 1:
    case 'PARADIGM_BINDING_STATE_VERIFIED':
      return ParadigmBindingState.PARADIGM_BINDING_STATE_VERIFIED
    case 2:
    case 'PARADIGM_BINDING_STATE_UNVERIFIED':
      return ParadigmBindingState.PARADIGM_BINDING_STATE_UNVERIFIED
    case 3:
    case 'PARADIGM_BINDING_STATE_MISMATCH':
      return ParadigmBindingState.PARADIGM_BINDING_STATE_MISMATCH
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ParadigmBindingState.UNRECOGNIZED
  }
}

export function paradigmBindingStateToJSON(object: ParadigmBindingState): string {
  switch (object) {
    case ParadigmBindingState.PARADIGM_BINDING_STATE_UNSPECIFIED:
      return 'PARADIGM_BINDING_STATE_UNSPECIFIED'
    case ParadigmBindingState.PARADIGM_BINDING_STATE_VERIFIED:
      return 'PARADIGM_BINDING_STATE_VERIFIED'
    case ParadigmBindingState.PARADIGM_BINDING_STATE_UNVERIFIED:
      return 'PARADIGM_BINDING_STATE_UNVERIFIED'
    case ParadigmBindingState.PARADIGM_BINDING_STATE_MISMATCH:
      return 'PARADIGM_BINDING_STATE_MISMATCH'
    case ParadigmBindingState.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** Account information */
export interface Account {
  accountId: string
  name: string
  status: AccountStatus
  apiKey?: string | undefined
  apiSecret?: string | undefined
  createdAt: string
  updatedAt: string
  lastAuthCheckAt?: string | undefined
  consecutiveAuthFailures?: number | undefined
  lastAuthError?: string | undefined
  retryAfter?: string | undefined
  /** Internal proxy IP for cloud environments, not shared publicly */
  internalIp?: string | undefined
  /** Public proxy IP for cloud environments */
  publicIp?: string | undefined
  /** Whether the account has completed its initial backfill of historical data */
  isBackfilled?: boolean | undefined
  /**
   * Execution venue identity. An account is identified by its trade venue,
   * not by an underlying market.
   */
  tradeVenue: TradeVenue
  /**
   * OAuth/app-login linkage (Deribit Registered Partner Model). When
   * auth_method == APP_USER, oauth_subject holds the stable Deribit user_id
   * and api_key/api_secret are unset; the venue re-auths via the app_user
   * grant using the app's own credentials from config.
   */
  oauthSubject?: string | undefined
  authMethod: AccountAuthMethod
  /**
   * Hyperliquid agent-wallet linkage, or Derive session-key linkage. When
   * auth_method == AGENT_WALLET, master_address holds the customer's master
   * account address (used for all info reads + WS user subscriptions) and
   * api_secret holds the server-minted agent key; the master key never reaches
   * the backend. When auth_method == SESSION_KEY, master_address holds the
   * customer's wallet address.
   */
  masterAddress?: string | undefined
  /**
   * Hyperliquid: the customer has signed approveBuilderFee, so orders may carry
   * the builder code. Unset/false ⇒ no builder stamping.
   */
  builderFeeApproved?: boolean | undefined
  /**
   * Hyperliquid agent (API) wallet expiry, or Derive session-key expiry —
   * absolute Unix ms (see PublicAccount). Unset for non-agent/non-session-key accounts.
   */
  agentValidUntil?: string | undefined
  /**
   * Epoch ms of the first time this account ever reached ACTIVE. Set once
   * (immutable) by record_auth_success / activate_agent_wallet via
   * DynamoDB if_not_exists; absent means the account has never activated.
   * This is the only reliable "never activated" signal — current `status`
   * alone conflates it with "activated once, now broken" (AUTH_FAILED and
   * PENDING_AUTH are both reachable either way). See oems_dynamodb::reaper.
   */
  firstActiveAt?: string | undefined
  /**
   * Independent of `is_backfilled` (trades/orders): tracks whether this
   * account's Deribit deposit/withdrawal history has been backfilled into
   * user_transfers. Most accounts already have is_backfilled = true before
   * this field exists, so it needs its own flag rather than reusing that one
   * — otherwise already-backfilled accounts would silently skip transfer
   * history entirely. See docs/superpowers/plans/2026-07-01-deribit-transfers.md.
   */
  transfersBackfilled?: boolean | undefined
  /**
   * Derive subaccount id this session key trades. Unset for non-Derive
   * accounts. A wallet may have multiple subaccounts; OEMS pins one per
   * OrderX account (mirrors how one Deribit account = one subaccount).
   */
  deriveSubaccountId?: number | undefined
  /**
   * Hyperliquid sub-account this agent-signed account trades as, via HL's
   * vaultAddress routing param. Unset (None) = the anchor, trades as the
   * master itself (today's only mode). Set = a linked sibling trading as
   * that sub-account. Mirrors derive_subaccount_id's shape for the
   * equivalent Derive concept.
   */
  hlVaultAddress?: string | undefined
  /**
   * Lighter (lighter.xyz) account index this API key trades — Lighter's
   * sibling of derive_subaccount_id. Unset for non-Lighter accounts. Lighter
   * has no delegated session key: api_secret holds this account's own
   * independent L2 Schnorr private key (40-byte scalar, hex-encoded, see
   * shared/lighter-crypto), decrypted per-instance; master_address holds the
   * L1 (zkSync) address that owns it.
   */
  lighterAccountIndex?: string | undefined
  /**
   * Lighter API-key slot (0-254, see MaxApiKeyIndex in lighter-go) this
   * credential occupies on lighter_account_index. Unset for non-Lighter
   * accounts.
   */
  lighterApiKeyIndex?: number | undefined
}

export interface AccountList {
  accounts: Account[]
}

export interface ParadigmBinding {
  accountName: string
  state: ParadigmBindingState
  /** powers "auto-fix" */
  suggestedAccountName?: string | undefined
  mismatchDetectedAtMs?: string | undefined
}

/** Public-safe account information (no sensitive credentials) */
export interface PublicAccount {
  accountId: string
  name: string
  status: AccountStatus
  /** Deliberately omit api_key and api_secret */
  createdAt: string
  updatedAt: string
  /** Public proxy IP for cloud environments */
  publicIp?: string | undefined
  /** Whether the account has completed its initial backfill of historical data */
  isBackfilled?: boolean | undefined
  /** Include last auth error for troubleshooting, but not retry_after or consecutive failures */
  lastAuthError?: string | undefined
  tradeVenue: TradeVenue
  /** Caller's own role on this account (from their link row). */
  role: AccountRole
  /**
   * How the account authenticates — drives the API-key form vs "Reconnect"
   * (OAuth) UI. oauth_subject itself is never exposed here.
   */
  authMethod: AccountAuthMethod
  /**
   * Hyperliquid agent (API) wallet expiry — absolute Unix ms. Lets the frontend
   * show a "Refresh connection" banner ahead of expiry (≤30d) without exposing
   * master_address or the agent key. Unset for non-agent-wallet accounts.
   */
  agentValidUntil?: string | undefined
  /**
   * Mirrors Account.first_active_at — absent means this account has never
   * activated. Drives "Cancel setup" (never activated, safe to hard-delete)
   * vs "Disconnect" (has real history, soft-disable only) in the frontend.
   */
  firstActiveAt?: string | undefined
  /** Paradigm RFQ desk nickname binding. Absent when never connected to Paradigm. */
  paradigmBinding: ParadigmBinding | undefined
}

/** Public account list for API responses */
export interface PublicAccountList {
  accounts: PublicAccount[]
}

export interface PortfolioData {
  accountId: string
  currency: string
  /** Decimal as string */
  equity: string
  /** Decimal as string */
  totalEquityUsd?: string | undefined
  timestamp: string
  tradeVenue: TradeVenue
  /**
   * Authoritative total account portfolio value in USD (the leverage
   * denominator), identical across every row of one account. Unlike
   * total_equity_usd — which is per-currency/per-component and which HL splits
   * across two `USDC` rows — this is the single account total each venue
   * computes itself. Absent when the venue can't report it (consumer falls back
   * to MAX of total_equity_usd). Decimal as string.
   */
  accountEquityUsd?: string | undefined
  /**
   * Per-dex equity breakdown backing perp margin: "main" for the main-dex
   * clearinghouse, the HIP-3 dex name (e.g. "xyz") for each builder dex the
   * account has equity in. Deribit, Bybit: margin balance for the single pool
   * under "main" (the basis their initial margin is charged against), absent
   * when the venue reports none. Decimal-as-string. Empty for venues without
   * this concept — consumers fall back to account_equity_usd.
   * Spot balances are never a key here — HL doesn't let spot back perp
   * margin without an explicit transfer.
   */
  perpEquityByDexUsd: { [key: string]: string }
  /**
   * Freely-sellable quantity of `currency`, in `currency` units — the venue's
   * own free figure, excluding order-locked and collateral-committed funds.
   * Absent when the venue can't determine it: consumers MUST refuse rather
   * than fall back to `equity`. Decimal as string.
   */
  availableQuantity?: string | undefined
  /**
   * Cost basis per unit of `currency`, in USD. Present only where the venue
   * reports a purchase price (Toss holdings); crypto wallet balances have
   * none. Decimal as string.
   */
  averagePurchasePriceUsd?: string | undefined
  /**
   * Canonical margin-model tag for THIS ROW's settlement currency: "SM" or
   * "PM" on Deribit, normalised from the venue's own name. Selects which
   * venue-measured margin curve a consumer may price against — an SM curve
   * does not describe a PM currency, and Deribit sets the model per
   * SETTLEMENT CURRENCY, so the row's own value is the only safe key. Absent
   * where the venue has no margin model, or reports one nobody has a curve
   * for; consumers MUST fall back to the flat scalar rather than guess.
   */
  marginModel?: string | undefined
  /**
   * The venue's OWN name for the ACCOUNT-WIDE model, verbatim and unmapped:
   * "cross_pm"/"segregated_sm"/"cross_spm_v3" (Deribit), "PORTFOLIO_MARGIN"
   * (Bybit), "PM2" (Derive). Deliberately NOT margin_model's per-currency
   * value: where the venue reports an account-level setting of its own
   * (Deribit's private/get_subaccounts), every currency row carries that same
   * account value, so consumers can fold it without a tie-break. Falls back to
   * the row's own model only until the venue has reported one. Unlike
   * margin_model this is never dropped for being unrecognised, so a model
   * nobody has mapped yet still reaches the UI. Display-only — never key a
   * margin curve off it.
   */
  marginModelLabel?: string | undefined
  /**
   * Decoded axes of the same account-wide model, for consumers that need to
   * branch rather than print. UNSPECIFIED where the venue reports no
   * account-level model (Hyperliquid and Lighter both pick scope per position
   * — see Position.margin_scope) or has no margin at all (spot).
   */
  marginScope: MarginScope
  marginMethod: MarginMethod
  /**
   * Venue-reported initial margin in use, per margin pool, in USD — keyed
   * like perp_equity_by_dex_usd ("main" for a venue with a single pool). This
   * is the venue's own account-level figure: it already nets whatever offsets
   * the venue's margin model grants (portfolio margin) and includes open-order
   * margin where the venue counts it, so it is NOT Σ Position.initial_margin_usd.
   * Empty when the venue reports none — consumers fall back to that sum.
   * Decimal as string.
   */
  initialMarginByPoolUsd: { [key: string]: string }
  /**
   * Scope of THIS ROW's settlement currency, from the row's own model rather
   * than the account-wide one margin_scope decodes. Deribit sets the model per
   * settlement currency, so a `segregated_pm` currency inside a `cross_pm`
   * account is ISOLATED here while margin_scope says CROSS — and margin_model
   * collapses both to "PM". A consumer netting positions across currencies
   * (portfolio-margin previews) must keep an ISOLATED currency's positions out
   * of every other currency's pool. UNSPECIFIED where the venue reports no
   * per-currency model; consumers fall back to margin_scope.
   */
  currencyMarginScope: MarginScope
  /**
   * Balance the venue holds back from `available_quantity` until its
   * settlement cycle pays it out (Papertrade payout queue, Decision #26).
   * Already counted in `equity`, never in `available_quantity`. Venues without
   * such a queue leave it unset.
   */
  queuedBalance?: string | undefined
}

export interface PortfolioData_PerpEquityByDexUsdEntry {
  key: string
  value: string
}

export interface PortfolioData_InitialMarginByPoolUsdEntry {
  key: string
  value: string
}

export interface PortfolioDataList {
  portfolioData: PortfolioData[]
}

/**
 * One maker/taker fee row. Superset across venues: Deribit keys by
 * instrument_type + index; Bybit keys by symbol (+ category).
 */
export interface FeeTier {
  /**
   * "option"|"perpetual"|"future" (Deribit) or category (Bybit). NOT
   * common.types.InstrumentType — that enum is {LINEAR,INVERSE}, the wrong axis
   * for these fee keys.
   */
  instrumentType: string
  /** Bybit per-symbol; Deribit per-index */
  symbol?: string | undefined
  /** Decimal as string */
  makerFee: string
  /** Decimal as string */
  takerFee: string
  /** Deribit "relative"|"fixed" */
  feeType?: string | undefined
  /** Deribit block-trade rate */
  blockTradeFee?: string | undefined
  /** Bybit option key (symbol is empty for options) */
  baseCoin?: string | undefined
}

export interface AccountFees {
  accountId: string
  tradeVenue: TradeVenue
  /** Deribit only; absent when no discount group */
  feeGroup?: string | undefined
  tiers: FeeTier[]
  timestamp: string
}

export interface AccountFeesList {
  accountFees: AccountFees[]
}

/**
 * Per-account, per-venue portfolio summary computed by public-api from the
 * position cache + latest venue equity. Leverage is delta_usd based:
 * gross_notional = Σ|delta_usd|, net_notional = Σ delta_usd; each divided by
 * equity_usd. PnL fields are USD roll-ups of the per-position metrics.
 * All decimal fields are Decimal-as-string.
 */
export interface AccountSummary {
  accountId: string
  tradeVenue: TradeVenue
  /**
   * Portfolio value (leverage denominator). "" when the venue can't value the
   * account right now (unpriced asset, reconnecting); show "—", not 0.
   */
  equityUsd: string
  /** Σ|delta_usd| */
  grossNotionalUsd: string
  /** Σ delta_usd (signed; sign = directional bias) */
  netNotionalUsd: string
  /** gross_notional_usd / equity_usd; "" when equity_usd is */
  grossLeverage: string
  /** |net_notional_usd| / equity_usd; "" when equity_usd is */
  netLeverage: string
  /** Σ unrealized_pnl_usd */
  unrealizedPnlUsd: string
  /** Σ realized_pnl_usd */
  realizedPnlUsd: string
  /** Σ daily_unrealized_pnl_usd */
  dailyUnrealizedPnlUsd: string
  timestamp: string
  /**
   * Multi-timeframe true PnL: equity(now) - equity(window_start) -
   * net_transfers(window). Exact and deposit/withdrawal-immune. Absent
   * (not just "0") when the account's trade_venue doesn't have transfer
   * ingestion live yet — frontend must treat absence as "fall back to the
   * legacy chart-delta / dailyUnrealizedPnlUsd behavior", not as zero PnL.
   */
  pnl1dUsd?: string | undefined
  pnl1wUsd?: string | undefined
  pnl1mUsd?: string | undefined
  pnlAllUsd?: string | undefined
  /**
   * The account's margin model, folded from its PortfolioData rows — which
   * all carry the venue's own account-wide value where it reports one, so the
   * fold is a plain unanimity check. Absent / UNSPECIFIED when the venue
   * reports no model at all, or when it only reports per-currency ones that
   * disagree: there is no single honest answer then, so read PortfolioData
   * per currency instead of rendering one of them.
   */
  marginModelLabel?: string | undefined
  marginScope: MarginScope
  marginMethod: MarginMethod
}

export interface AccountSummaryList {
  accountSummary: AccountSummary[]
}

function createBaseAccount(): Account {
  return {
    accountId: '',
    name: '',
    status: 0,
    apiKey: undefined,
    apiSecret: undefined,
    createdAt: '0',
    updatedAt: '0',
    lastAuthCheckAt: undefined,
    consecutiveAuthFailures: undefined,
    lastAuthError: undefined,
    retryAfter: undefined,
    internalIp: undefined,
    publicIp: undefined,
    isBackfilled: undefined,
    tradeVenue: 0,
    oauthSubject: undefined,
    authMethod: 0,
    masterAddress: undefined,
    builderFeeApproved: undefined,
    agentValidUntil: undefined,
    firstActiveAt: undefined,
    transfersBackfilled: undefined,
    deriveSubaccountId: undefined,
    hlVaultAddress: undefined,
    lighterAccountIndex: undefined,
    lighterApiKeyIndex: undefined,
  }
}

export const Account: MessageFns<Account> = {
  encode(message: Account, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(18).string(message.accountId)
    }
    if (message.name !== '') {
      writer.uint32(26).string(message.name)
    }
    if (message.status !== 0) {
      writer.uint32(40).int32(message.status)
    }
    if (message.apiKey !== undefined) {
      writer.uint32(50).string(message.apiKey)
    }
    if (message.apiSecret !== undefined) {
      writer.uint32(58).string(message.apiSecret)
    }
    if (message.createdAt !== '0') {
      writer.uint32(64).int64(message.createdAt)
    }
    if (message.updatedAt !== '0') {
      writer.uint32(72).int64(message.updatedAt)
    }
    if (message.lastAuthCheckAt !== undefined) {
      writer.uint32(80).int64(message.lastAuthCheckAt)
    }
    if (message.consecutiveAuthFailures !== undefined) {
      writer.uint32(88).int32(message.consecutiveAuthFailures)
    }
    if (message.lastAuthError !== undefined) {
      writer.uint32(98).string(message.lastAuthError)
    }
    if (message.retryAfter !== undefined) {
      writer.uint32(104).int64(message.retryAfter)
    }
    if (message.internalIp !== undefined) {
      writer.uint32(114).string(message.internalIp)
    }
    if (message.publicIp !== undefined) {
      writer.uint32(122).string(message.publicIp)
    }
    if (message.isBackfilled !== undefined) {
      writer.uint32(128).bool(message.isBackfilled)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(136).int32(message.tradeVenue)
    }
    if (message.oauthSubject !== undefined) {
      writer.uint32(146).string(message.oauthSubject)
    }
    if (message.authMethod !== 0) {
      writer.uint32(152).int32(message.authMethod)
    }
    if (message.masterAddress !== undefined) {
      writer.uint32(162).string(message.masterAddress)
    }
    if (message.builderFeeApproved !== undefined) {
      writer.uint32(168).bool(message.builderFeeApproved)
    }
    if (message.agentValidUntil !== undefined) {
      writer.uint32(176).int64(message.agentValidUntil)
    }
    if (message.firstActiveAt !== undefined) {
      writer.uint32(184).int64(message.firstActiveAt)
    }
    if (message.transfersBackfilled !== undefined) {
      writer.uint32(192).bool(message.transfersBackfilled)
    }
    if (message.deriveSubaccountId !== undefined) {
      writer.uint32(200).int32(message.deriveSubaccountId)
    }
    if (message.hlVaultAddress !== undefined) {
      writer.uint32(210).string(message.hlVaultAddress)
    }
    if (message.lighterAccountIndex !== undefined) {
      writer.uint32(224).int64(message.lighterAccountIndex)
    }
    if (message.lighterApiKeyIndex !== undefined) {
      writer.uint32(232).uint32(message.lighterApiKeyIndex)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Account {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAccount()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.status = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.apiKey = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.apiSecret = reader.string()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.updatedAt = reader.int64().toString()
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.lastAuthCheckAt = reader.int64().toString()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.consecutiveAuthFailures = reader.int32()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.lastAuthError = reader.string()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.retryAfter = reader.int64().toString()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.internalIp = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.publicIp = reader.string()
          continue
        }
        case 16: {
          if (tag !== 128) {
            break
          }

          message.isBackfilled = reader.bool()
          continue
        }
        case 17: {
          if (tag !== 136) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 18: {
          if (tag !== 146) {
            break
          }

          message.oauthSubject = reader.string()
          continue
        }
        case 19: {
          if (tag !== 152) {
            break
          }

          message.authMethod = reader.int32() as any
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.masterAddress = reader.string()
          continue
        }
        case 21: {
          if (tag !== 168) {
            break
          }

          message.builderFeeApproved = reader.bool()
          continue
        }
        case 22: {
          if (tag !== 176) {
            break
          }

          message.agentValidUntil = reader.int64().toString()
          continue
        }
        case 23: {
          if (tag !== 184) {
            break
          }

          message.firstActiveAt = reader.int64().toString()
          continue
        }
        case 24: {
          if (tag !== 192) {
            break
          }

          message.transfersBackfilled = reader.bool()
          continue
        }
        case 25: {
          if (tag !== 200) {
            break
          }

          message.deriveSubaccountId = reader.int32()
          continue
        }
        case 26: {
          if (tag !== 210) {
            break
          }

          message.hlVaultAddress = reader.string()
          continue
        }
        case 28: {
          if (tag !== 224) {
            break
          }

          message.lighterAccountIndex = reader.int64().toString()
          continue
        }
        case 29: {
          if (tag !== 232) {
            break
          }

          message.lighterApiKeyIndex = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Account {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      status: isSet(object.status) ? accountStatusFromJSON(object.status) : 0,
      apiKey: isSet(object.apiKey)
        ? globalThis.String(object.apiKey)
        : isSet(object.api_key)
          ? globalThis.String(object.api_key)
          : undefined,
      apiSecret: isSet(object.apiSecret)
        ? globalThis.String(object.apiSecret)
        : isSet(object.api_secret)
          ? globalThis.String(object.api_secret)
          : undefined,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
          ? globalThis.String(object.updated_at)
          : '0',
      lastAuthCheckAt: isSet(object.lastAuthCheckAt)
        ? globalThis.String(object.lastAuthCheckAt)
        : isSet(object.last_auth_check_at)
          ? globalThis.String(object.last_auth_check_at)
          : undefined,
      consecutiveAuthFailures: isSet(object.consecutiveAuthFailures)
        ? globalThis.Number(object.consecutiveAuthFailures)
        : isSet(object.consecutive_auth_failures)
          ? globalThis.Number(object.consecutive_auth_failures)
          : undefined,
      lastAuthError: isSet(object.lastAuthError)
        ? globalThis.String(object.lastAuthError)
        : isSet(object.last_auth_error)
          ? globalThis.String(object.last_auth_error)
          : undefined,
      retryAfter: isSet(object.retryAfter)
        ? globalThis.String(object.retryAfter)
        : isSet(object.retry_after)
          ? globalThis.String(object.retry_after)
          : undefined,
      internalIp: isSet(object.internalIp)
        ? globalThis.String(object.internalIp)
        : isSet(object.internal_ip)
          ? globalThis.String(object.internal_ip)
          : undefined,
      publicIp: isSet(object.publicIp)
        ? globalThis.String(object.publicIp)
        : isSet(object.public_ip)
          ? globalThis.String(object.public_ip)
          : undefined,
      isBackfilled: isSet(object.isBackfilled)
        ? globalThis.Boolean(object.isBackfilled)
        : isSet(object.is_backfilled)
          ? globalThis.Boolean(object.is_backfilled)
          : undefined,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      oauthSubject: isSet(object.oauthSubject)
        ? globalThis.String(object.oauthSubject)
        : isSet(object.oauth_subject)
          ? globalThis.String(object.oauth_subject)
          : undefined,
      authMethod: isSet(object.authMethod)
        ? accountAuthMethodFromJSON(object.authMethod)
        : isSet(object.auth_method)
          ? accountAuthMethodFromJSON(object.auth_method)
          : 0,
      masterAddress: isSet(object.masterAddress)
        ? globalThis.String(object.masterAddress)
        : isSet(object.master_address)
          ? globalThis.String(object.master_address)
          : undefined,
      builderFeeApproved: isSet(object.builderFeeApproved)
        ? globalThis.Boolean(object.builderFeeApproved)
        : isSet(object.builder_fee_approved)
          ? globalThis.Boolean(object.builder_fee_approved)
          : undefined,
      agentValidUntil: isSet(object.agentValidUntil)
        ? globalThis.String(object.agentValidUntil)
        : isSet(object.agent_valid_until)
          ? globalThis.String(object.agent_valid_until)
          : undefined,
      firstActiveAt: isSet(object.firstActiveAt)
        ? globalThis.String(object.firstActiveAt)
        : isSet(object.first_active_at)
          ? globalThis.String(object.first_active_at)
          : undefined,
      transfersBackfilled: isSet(object.transfersBackfilled)
        ? globalThis.Boolean(object.transfersBackfilled)
        : isSet(object.transfers_backfilled)
          ? globalThis.Boolean(object.transfers_backfilled)
          : undefined,
      deriveSubaccountId: isSet(object.deriveSubaccountId)
        ? globalThis.Number(object.deriveSubaccountId)
        : isSet(object.derive_subaccount_id)
          ? globalThis.Number(object.derive_subaccount_id)
          : undefined,
      hlVaultAddress: isSet(object.hlVaultAddress)
        ? globalThis.String(object.hlVaultAddress)
        : isSet(object.hl_vault_address)
          ? globalThis.String(object.hl_vault_address)
          : undefined,
      lighterAccountIndex: isSet(object.lighterAccountIndex)
        ? globalThis.String(object.lighterAccountIndex)
        : isSet(object.lighter_account_index)
          ? globalThis.String(object.lighter_account_index)
          : undefined,
      lighterApiKeyIndex: isSet(object.lighterApiKeyIndex)
        ? globalThis.Number(object.lighterApiKeyIndex)
        : isSet(object.lighter_api_key_index)
          ? globalThis.Number(object.lighter_api_key_index)
          : undefined,
    }
  },

  toJSON(message: Account): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.status !== 0) {
      obj.status = accountStatusToJSON(message.status)
    }
    if (message.apiKey !== undefined) {
      obj.apiKey = message.apiKey
    }
    if (message.apiSecret !== undefined) {
      obj.apiSecret = message.apiSecret
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    if (message.updatedAt !== '0') {
      obj.updatedAt = message.updatedAt
    }
    if (message.lastAuthCheckAt !== undefined) {
      obj.lastAuthCheckAt = message.lastAuthCheckAt
    }
    if (message.consecutiveAuthFailures !== undefined) {
      obj.consecutiveAuthFailures = Math.round(message.consecutiveAuthFailures)
    }
    if (message.lastAuthError !== undefined) {
      obj.lastAuthError = message.lastAuthError
    }
    if (message.retryAfter !== undefined) {
      obj.retryAfter = message.retryAfter
    }
    if (message.internalIp !== undefined) {
      obj.internalIp = message.internalIp
    }
    if (message.publicIp !== undefined) {
      obj.publicIp = message.publicIp
    }
    if (message.isBackfilled !== undefined) {
      obj.isBackfilled = message.isBackfilled
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.oauthSubject !== undefined) {
      obj.oauthSubject = message.oauthSubject
    }
    if (message.authMethod !== 0) {
      obj.authMethod = accountAuthMethodToJSON(message.authMethod)
    }
    if (message.masterAddress !== undefined) {
      obj.masterAddress = message.masterAddress
    }
    if (message.builderFeeApproved !== undefined) {
      obj.builderFeeApproved = message.builderFeeApproved
    }
    if (message.agentValidUntil !== undefined) {
      obj.agentValidUntil = message.agentValidUntil
    }
    if (message.firstActiveAt !== undefined) {
      obj.firstActiveAt = message.firstActiveAt
    }
    if (message.transfersBackfilled !== undefined) {
      obj.transfersBackfilled = message.transfersBackfilled
    }
    if (message.deriveSubaccountId !== undefined) {
      obj.deriveSubaccountId = Math.round(message.deriveSubaccountId)
    }
    if (message.hlVaultAddress !== undefined) {
      obj.hlVaultAddress = message.hlVaultAddress
    }
    if (message.lighterAccountIndex !== undefined) {
      obj.lighterAccountIndex = message.lighterAccountIndex
    }
    if (message.lighterApiKeyIndex !== undefined) {
      obj.lighterApiKeyIndex = Math.round(message.lighterApiKeyIndex)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Account>, I>>(base?: I): Account {
    return Account.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Account>, I>>(object: I): Account {
    const message = createBaseAccount()
    message.accountId = object.accountId ?? ''
    message.name = object.name ?? ''
    message.status = object.status ?? 0
    message.apiKey = object.apiKey ?? undefined
    message.apiSecret = object.apiSecret ?? undefined
    message.createdAt = object.createdAt ?? '0'
    message.updatedAt = object.updatedAt ?? '0'
    message.lastAuthCheckAt = object.lastAuthCheckAt ?? undefined
    message.consecutiveAuthFailures = object.consecutiveAuthFailures ?? undefined
    message.lastAuthError = object.lastAuthError ?? undefined
    message.retryAfter = object.retryAfter ?? undefined
    message.internalIp = object.internalIp ?? undefined
    message.publicIp = object.publicIp ?? undefined
    message.isBackfilled = object.isBackfilled ?? undefined
    message.tradeVenue = object.tradeVenue ?? 0
    message.oauthSubject = object.oauthSubject ?? undefined
    message.authMethod = object.authMethod ?? 0
    message.masterAddress = object.masterAddress ?? undefined
    message.builderFeeApproved = object.builderFeeApproved ?? undefined
    message.agentValidUntil = object.agentValidUntil ?? undefined
    message.firstActiveAt = object.firstActiveAt ?? undefined
    message.transfersBackfilled = object.transfersBackfilled ?? undefined
    message.deriveSubaccountId = object.deriveSubaccountId ?? undefined
    message.hlVaultAddress = object.hlVaultAddress ?? undefined
    message.lighterAccountIndex = object.lighterAccountIndex ?? undefined
    message.lighterApiKeyIndex = object.lighterApiKeyIndex ?? undefined
    return message
  },
}

function createBaseAccountList(): AccountList {
  return { accounts: [] }
}

export const AccountList: MessageFns<AccountList> = {
  encode(message: AccountList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.accounts) {
      Account.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccountList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAccountList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accounts.push(Account.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AccountList {
    return {
      accounts: globalThis.Array.isArray(object?.accounts)
        ? object.accounts.map((e: any) => Account.fromJSON(e))
        : [],
    }
  },

  toJSON(message: AccountList): unknown {
    const obj: any = {}
    if (message.accounts?.length) {
      obj.accounts = message.accounts.map((e) => Account.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AccountList>, I>>(base?: I): AccountList {
    return AccountList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AccountList>, I>>(object: I): AccountList {
    const message = createBaseAccountList()
    message.accounts = object.accounts?.map((e) => Account.fromPartial(e)) || []
    return message
  },
}

function createBaseParadigmBinding(): ParadigmBinding {
  return {
    accountName: '',
    state: 0,
    suggestedAccountName: undefined,
    mismatchDetectedAtMs: undefined,
  }
}

export const ParadigmBinding: MessageFns<ParadigmBinding> = {
  encode(message: ParadigmBinding, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountName !== '') {
      writer.uint32(10).string(message.accountName)
    }
    if (message.state !== 0) {
      writer.uint32(16).int32(message.state)
    }
    if (message.suggestedAccountName !== undefined) {
      writer.uint32(26).string(message.suggestedAccountName)
    }
    if (message.mismatchDetectedAtMs !== undefined) {
      writer.uint32(32).int64(message.mismatchDetectedAtMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ParadigmBinding {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseParadigmBinding()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountName = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.state = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.suggestedAccountName = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.mismatchDetectedAtMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ParadigmBinding {
    return {
      accountName: isSet(object.accountName)
        ? globalThis.String(object.accountName)
        : isSet(object.account_name)
          ? globalThis.String(object.account_name)
          : '',
      state: isSet(object.state) ? paradigmBindingStateFromJSON(object.state) : 0,
      suggestedAccountName: isSet(object.suggestedAccountName)
        ? globalThis.String(object.suggestedAccountName)
        : isSet(object.suggested_account_name)
          ? globalThis.String(object.suggested_account_name)
          : undefined,
      mismatchDetectedAtMs: isSet(object.mismatchDetectedAtMs)
        ? globalThis.String(object.mismatchDetectedAtMs)
        : isSet(object.mismatch_detected_at_ms)
          ? globalThis.String(object.mismatch_detected_at_ms)
          : undefined,
    }
  },

  toJSON(message: ParadigmBinding): unknown {
    const obj: any = {}
    if (message.accountName !== '') {
      obj.accountName = message.accountName
    }
    if (message.state !== 0) {
      obj.state = paradigmBindingStateToJSON(message.state)
    }
    if (message.suggestedAccountName !== undefined) {
      obj.suggestedAccountName = message.suggestedAccountName
    }
    if (message.mismatchDetectedAtMs !== undefined) {
      obj.mismatchDetectedAtMs = message.mismatchDetectedAtMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ParadigmBinding>, I>>(base?: I): ParadigmBinding {
    return ParadigmBinding.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ParadigmBinding>, I>>(object: I): ParadigmBinding {
    const message = createBaseParadigmBinding()
    message.accountName = object.accountName ?? ''
    message.state = object.state ?? 0
    message.suggestedAccountName = object.suggestedAccountName ?? undefined
    message.mismatchDetectedAtMs = object.mismatchDetectedAtMs ?? undefined
    return message
  },
}

function createBasePublicAccount(): PublicAccount {
  return {
    accountId: '',
    name: '',
    status: 0,
    createdAt: '0',
    updatedAt: '0',
    publicIp: undefined,
    isBackfilled: undefined,
    lastAuthError: undefined,
    tradeVenue: 0,
    role: 0,
    authMethod: 0,
    agentValidUntil: undefined,
    firstActiveAt: undefined,
    paradigmBinding: undefined,
  }
}

export const PublicAccount: MessageFns<PublicAccount> = {
  encode(message: PublicAccount, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(18).string(message.accountId)
    }
    if (message.name !== '') {
      writer.uint32(26).string(message.name)
    }
    if (message.status !== 0) {
      writer.uint32(40).int32(message.status)
    }
    if (message.createdAt !== '0') {
      writer.uint32(48).int64(message.createdAt)
    }
    if (message.updatedAt !== '0') {
      writer.uint32(56).int64(message.updatedAt)
    }
    if (message.publicIp !== undefined) {
      writer.uint32(66).string(message.publicIp)
    }
    if (message.isBackfilled !== undefined) {
      writer.uint32(72).bool(message.isBackfilled)
    }
    if (message.lastAuthError !== undefined) {
      writer.uint32(82).string(message.lastAuthError)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(88).int32(message.tradeVenue)
    }
    if (message.role !== 0) {
      writer.uint32(96).int32(message.role)
    }
    if (message.authMethod !== 0) {
      writer.uint32(104).int32(message.authMethod)
    }
    if (message.agentValidUntil !== undefined) {
      writer.uint32(112).int64(message.agentValidUntil)
    }
    if (message.firstActiveAt !== undefined) {
      writer.uint32(120).int64(message.firstActiveAt)
    }
    if (message.paradigmBinding !== undefined) {
      ParadigmBinding.encode(message.paradigmBinding, writer.uint32(130).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PublicAccount {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePublicAccount()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.status = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.updatedAt = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.publicIp = reader.string()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.isBackfilled = reader.bool()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.lastAuthError = reader.string()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 12: {
          if (tag !== 96) {
            break
          }

          message.role = reader.int32() as any
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.authMethod = reader.int32() as any
          continue
        }
        case 14: {
          if (tag !== 112) {
            break
          }

          message.agentValidUntil = reader.int64().toString()
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.firstActiveAt = reader.int64().toString()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.paradigmBinding = ParadigmBinding.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PublicAccount {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      status: isSet(object.status) ? accountStatusFromJSON(object.status) : 0,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
          ? globalThis.String(object.updated_at)
          : '0',
      publicIp: isSet(object.publicIp)
        ? globalThis.String(object.publicIp)
        : isSet(object.public_ip)
          ? globalThis.String(object.public_ip)
          : undefined,
      isBackfilled: isSet(object.isBackfilled)
        ? globalThis.Boolean(object.isBackfilled)
        : isSet(object.is_backfilled)
          ? globalThis.Boolean(object.is_backfilled)
          : undefined,
      lastAuthError: isSet(object.lastAuthError)
        ? globalThis.String(object.lastAuthError)
        : isSet(object.last_auth_error)
          ? globalThis.String(object.last_auth_error)
          : undefined,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      role: isSet(object.role) ? accountRoleFromJSON(object.role) : 0,
      authMethod: isSet(object.authMethod)
        ? accountAuthMethodFromJSON(object.authMethod)
        : isSet(object.auth_method)
          ? accountAuthMethodFromJSON(object.auth_method)
          : 0,
      agentValidUntil: isSet(object.agentValidUntil)
        ? globalThis.String(object.agentValidUntil)
        : isSet(object.agent_valid_until)
          ? globalThis.String(object.agent_valid_until)
          : undefined,
      firstActiveAt: isSet(object.firstActiveAt)
        ? globalThis.String(object.firstActiveAt)
        : isSet(object.first_active_at)
          ? globalThis.String(object.first_active_at)
          : undefined,
      paradigmBinding: isSet(object.paradigmBinding)
        ? ParadigmBinding.fromJSON(object.paradigmBinding)
        : isSet(object.paradigm_binding)
          ? ParadigmBinding.fromJSON(object.paradigm_binding)
          : undefined,
    }
  },

  toJSON(message: PublicAccount): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.status !== 0) {
      obj.status = accountStatusToJSON(message.status)
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    if (message.updatedAt !== '0') {
      obj.updatedAt = message.updatedAt
    }
    if (message.publicIp !== undefined) {
      obj.publicIp = message.publicIp
    }
    if (message.isBackfilled !== undefined) {
      obj.isBackfilled = message.isBackfilled
    }
    if (message.lastAuthError !== undefined) {
      obj.lastAuthError = message.lastAuthError
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.role !== 0) {
      obj.role = accountRoleToJSON(message.role)
    }
    if (message.authMethod !== 0) {
      obj.authMethod = accountAuthMethodToJSON(message.authMethod)
    }
    if (message.agentValidUntil !== undefined) {
      obj.agentValidUntil = message.agentValidUntil
    }
    if (message.firstActiveAt !== undefined) {
      obj.firstActiveAt = message.firstActiveAt
    }
    if (message.paradigmBinding !== undefined) {
      obj.paradigmBinding = ParadigmBinding.toJSON(message.paradigmBinding)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PublicAccount>, I>>(base?: I): PublicAccount {
    return PublicAccount.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PublicAccount>, I>>(object: I): PublicAccount {
    const message = createBasePublicAccount()
    message.accountId = object.accountId ?? ''
    message.name = object.name ?? ''
    message.status = object.status ?? 0
    message.createdAt = object.createdAt ?? '0'
    message.updatedAt = object.updatedAt ?? '0'
    message.publicIp = object.publicIp ?? undefined
    message.isBackfilled = object.isBackfilled ?? undefined
    message.lastAuthError = object.lastAuthError ?? undefined
    message.tradeVenue = object.tradeVenue ?? 0
    message.role = object.role ?? 0
    message.authMethod = object.authMethod ?? 0
    message.agentValidUntil = object.agentValidUntil ?? undefined
    message.firstActiveAt = object.firstActiveAt ?? undefined
    message.paradigmBinding =
      object.paradigmBinding !== undefined && object.paradigmBinding !== null
        ? ParadigmBinding.fromPartial(object.paradigmBinding)
        : undefined
    return message
  },
}

function createBasePublicAccountList(): PublicAccountList {
  return { accounts: [] }
}

export const PublicAccountList: MessageFns<PublicAccountList> = {
  encode(message: PublicAccountList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.accounts) {
      PublicAccount.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PublicAccountList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePublicAccountList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accounts.push(PublicAccount.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PublicAccountList {
    return {
      accounts: globalThis.Array.isArray(object?.accounts)
        ? object.accounts.map((e: any) => PublicAccount.fromJSON(e))
        : [],
    }
  },

  toJSON(message: PublicAccountList): unknown {
    const obj: any = {}
    if (message.accounts?.length) {
      obj.accounts = message.accounts.map((e) => PublicAccount.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PublicAccountList>, I>>(base?: I): PublicAccountList {
    return PublicAccountList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PublicAccountList>, I>>(object: I): PublicAccountList {
    const message = createBasePublicAccountList()
    message.accounts = object.accounts?.map((e) => PublicAccount.fromPartial(e)) || []
    return message
  },
}

function createBasePortfolioData(): PortfolioData {
  return {
    accountId: '',
    currency: '',
    equity: '',
    totalEquityUsd: undefined,
    timestamp: '0',
    tradeVenue: 0,
    accountEquityUsd: undefined,
    perpEquityByDexUsd: {},
    availableQuantity: undefined,
    averagePurchasePriceUsd: undefined,
    marginModel: undefined,
    marginModelLabel: undefined,
    marginScope: 0,
    marginMethod: 0,
    initialMarginByPoolUsd: {},
    currencyMarginScope: 0,
    queuedBalance: undefined,
  }
}

export const PortfolioData: MessageFns<PortfolioData> = {
  encode(message: PortfolioData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.currency !== '') {
      writer.uint32(26).string(message.currency)
    }
    if (message.equity !== '') {
      writer.uint32(34).string(message.equity)
    }
    if (message.totalEquityUsd !== undefined) {
      writer.uint32(42).string(message.totalEquityUsd)
    }
    if (message.timestamp !== '0') {
      writer.uint32(56).int64(message.timestamp)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(64).int32(message.tradeVenue)
    }
    if (message.accountEquityUsd !== undefined) {
      writer.uint32(74).string(message.accountEquityUsd)
    }
    globalThis.Object.entries(message.perpEquityByDexUsd).forEach(
      ([key, value]: [string, string]) => {
        PortfolioData_PerpEquityByDexUsdEntry.encode(
          { key: key as any, value },
          writer.uint32(82).fork()
        ).join()
      }
    )
    if (message.availableQuantity !== undefined) {
      writer.uint32(90).string(message.availableQuantity)
    }
    if (message.averagePurchasePriceUsd !== undefined) {
      writer.uint32(98).string(message.averagePurchasePriceUsd)
    }
    if (message.marginModel !== undefined) {
      writer.uint32(106).string(message.marginModel)
    }
    if (message.marginModelLabel !== undefined) {
      writer.uint32(114).string(message.marginModelLabel)
    }
    if (message.marginScope !== 0) {
      writer.uint32(120).int32(message.marginScope)
    }
    if (message.marginMethod !== 0) {
      writer.uint32(128).int32(message.marginMethod)
    }
    globalThis.Object.entries(message.initialMarginByPoolUsd).forEach(
      ([key, value]: [string, string]) => {
        PortfolioData_InitialMarginByPoolUsdEntry.encode(
          { key: key as any, value },
          writer.uint32(138).fork()
        ).join()
      }
    )
    if (message.currencyMarginScope !== 0) {
      writer.uint32(144).int32(message.currencyMarginScope)
    }
    if (message.queuedBalance !== undefined) {
      writer.uint32(154).string(message.queuedBalance)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortfolioData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePortfolioData()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.equity = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.totalEquityUsd = reader.string()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.timestamp = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.accountEquityUsd = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          const entry10 = PortfolioData_PerpEquityByDexUsdEntry.decode(reader, reader.uint32())
          if (entry10.value !== undefined) {
            message.perpEquityByDexUsd[entry10.key] = entry10.value
          }
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.availableQuantity = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.averagePurchasePriceUsd = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.marginModel = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.marginModelLabel = reader.string()
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.marginScope = reader.int32() as any
          continue
        }
        case 16: {
          if (tag !== 128) {
            break
          }

          message.marginMethod = reader.int32() as any
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          const entry17 = PortfolioData_InitialMarginByPoolUsdEntry.decode(reader, reader.uint32())
          if (entry17.value !== undefined) {
            message.initialMarginByPoolUsd[entry17.key] = entry17.value
          }
          continue
        }
        case 18: {
          if (tag !== 144) {
            break
          }

          message.currencyMarginScope = reader.int32() as any
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.queuedBalance = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PortfolioData {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      equity: isSet(object.equity) ? globalThis.String(object.equity) : '',
      totalEquityUsd: isSet(object.totalEquityUsd)
        ? globalThis.String(object.totalEquityUsd)
        : isSet(object.total_equity_usd)
          ? globalThis.String(object.total_equity_usd)
          : undefined,
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '0',
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      accountEquityUsd: isSet(object.accountEquityUsd)
        ? globalThis.String(object.accountEquityUsd)
        : isSet(object.account_equity_usd)
          ? globalThis.String(object.account_equity_usd)
          : undefined,
      perpEquityByDexUsd: isObject(object.perpEquityByDexUsd)
        ? (globalThis.Object.entries(object.perpEquityByDexUsd) as [string, any][]).reduce(
            (acc: { [key: string]: string }, [key, value]: [string, any]) => {
              acc[key] = globalThis.String(value)
              return acc
            },
            {}
          )
        : isObject(object.perp_equity_by_dex_usd)
          ? (globalThis.Object.entries(object.perp_equity_by_dex_usd) as [string, any][]).reduce(
              (acc: { [key: string]: string }, [key, value]: [string, any]) => {
                acc[key] = globalThis.String(value)
                return acc
              },
              {}
            )
          : {},
      availableQuantity: isSet(object.availableQuantity)
        ? globalThis.String(object.availableQuantity)
        : isSet(object.available_quantity)
          ? globalThis.String(object.available_quantity)
          : undefined,
      averagePurchasePriceUsd: isSet(object.averagePurchasePriceUsd)
        ? globalThis.String(object.averagePurchasePriceUsd)
        : isSet(object.average_purchase_price_usd)
          ? globalThis.String(object.average_purchase_price_usd)
          : undefined,
      marginModel: isSet(object.marginModel)
        ? globalThis.String(object.marginModel)
        : isSet(object.margin_model)
          ? globalThis.String(object.margin_model)
          : undefined,
      marginModelLabel: isSet(object.marginModelLabel)
        ? globalThis.String(object.marginModelLabel)
        : isSet(object.margin_model_label)
          ? globalThis.String(object.margin_model_label)
          : undefined,
      marginScope: isSet(object.marginScope)
        ? marginScopeFromJSON(object.marginScope)
        : isSet(object.margin_scope)
          ? marginScopeFromJSON(object.margin_scope)
          : 0,
      marginMethod: isSet(object.marginMethod)
        ? marginMethodFromJSON(object.marginMethod)
        : isSet(object.margin_method)
          ? marginMethodFromJSON(object.margin_method)
          : 0,
      initialMarginByPoolUsd: isObject(object.initialMarginByPoolUsd)
        ? (globalThis.Object.entries(object.initialMarginByPoolUsd) as [string, any][]).reduce(
            (acc: { [key: string]: string }, [key, value]: [string, any]) => {
              acc[key] = globalThis.String(value)
              return acc
            },
            {}
          )
        : isObject(object.initial_margin_by_pool_usd)
          ? (
              globalThis.Object.entries(object.initial_margin_by_pool_usd) as [string, any][]
            ).reduce((acc: { [key: string]: string }, [key, value]: [string, any]) => {
              acc[key] = globalThis.String(value)
              return acc
            }, {})
          : {},
      currencyMarginScope: isSet(object.currencyMarginScope)
        ? marginScopeFromJSON(object.currencyMarginScope)
        : isSet(object.currency_margin_scope)
          ? marginScopeFromJSON(object.currency_margin_scope)
          : 0,
      queuedBalance: isSet(object.queuedBalance)
        ? globalThis.String(object.queuedBalance)
        : isSet(object.queued_balance)
          ? globalThis.String(object.queued_balance)
          : undefined,
    }
  },

  toJSON(message: PortfolioData): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.equity !== '') {
      obj.equity = message.equity
    }
    if (message.totalEquityUsd !== undefined) {
      obj.totalEquityUsd = message.totalEquityUsd
    }
    if (message.timestamp !== '0') {
      obj.timestamp = message.timestamp
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.accountEquityUsd !== undefined) {
      obj.accountEquityUsd = message.accountEquityUsd
    }
    if (message.perpEquityByDexUsd) {
      const entries = globalThis.Object.entries(message.perpEquityByDexUsd) as [string, string][]
      if (entries.length > 0) {
        obj.perpEquityByDexUsd = {}
        entries.forEach(([k, v]) => {
          obj.perpEquityByDexUsd[k] = v
        })
      }
    }
    if (message.availableQuantity !== undefined) {
      obj.availableQuantity = message.availableQuantity
    }
    if (message.averagePurchasePriceUsd !== undefined) {
      obj.averagePurchasePriceUsd = message.averagePurchasePriceUsd
    }
    if (message.marginModel !== undefined) {
      obj.marginModel = message.marginModel
    }
    if (message.marginModelLabel !== undefined) {
      obj.marginModelLabel = message.marginModelLabel
    }
    if (message.marginScope !== 0) {
      obj.marginScope = marginScopeToJSON(message.marginScope)
    }
    if (message.marginMethod !== 0) {
      obj.marginMethod = marginMethodToJSON(message.marginMethod)
    }
    if (message.initialMarginByPoolUsd) {
      const entries = globalThis.Object.entries(message.initialMarginByPoolUsd) as [
        string,
        string,
      ][]
      if (entries.length > 0) {
        obj.initialMarginByPoolUsd = {}
        entries.forEach(([k, v]) => {
          obj.initialMarginByPoolUsd[k] = v
        })
      }
    }
    if (message.currencyMarginScope !== 0) {
      obj.currencyMarginScope = marginScopeToJSON(message.currencyMarginScope)
    }
    if (message.queuedBalance !== undefined) {
      obj.queuedBalance = message.queuedBalance
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PortfolioData>, I>>(base?: I): PortfolioData {
    return PortfolioData.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PortfolioData>, I>>(object: I): PortfolioData {
    const message = createBasePortfolioData()
    message.accountId = object.accountId ?? ''
    message.currency = object.currency ?? ''
    message.equity = object.equity ?? ''
    message.totalEquityUsd = object.totalEquityUsd ?? undefined
    message.timestamp = object.timestamp ?? '0'
    message.tradeVenue = object.tradeVenue ?? 0
    message.accountEquityUsd = object.accountEquityUsd ?? undefined
    message.perpEquityByDexUsd = (
      globalThis.Object.entries(object.perpEquityByDexUsd ?? {}) as [string, string][]
    ).reduce((acc: { [key: string]: string }, [key, value]: [string, string]) => {
      if (value !== undefined) {
        acc[key] = globalThis.String(value)
      }
      return acc
    }, {})
    message.availableQuantity = object.availableQuantity ?? undefined
    message.averagePurchasePriceUsd = object.averagePurchasePriceUsd ?? undefined
    message.marginModel = object.marginModel ?? undefined
    message.marginModelLabel = object.marginModelLabel ?? undefined
    message.marginScope = object.marginScope ?? 0
    message.marginMethod = object.marginMethod ?? 0
    message.initialMarginByPoolUsd = (
      globalThis.Object.entries(object.initialMarginByPoolUsd ?? {}) as [string, string][]
    ).reduce((acc: { [key: string]: string }, [key, value]: [string, string]) => {
      if (value !== undefined) {
        acc[key] = globalThis.String(value)
      }
      return acc
    }, {})
    message.currencyMarginScope = object.currencyMarginScope ?? 0
    message.queuedBalance = object.queuedBalance ?? undefined
    return message
  },
}

function createBasePortfolioData_PerpEquityByDexUsdEntry(): PortfolioData_PerpEquityByDexUsdEntry {
  return { key: '', value: '' }
}

export const PortfolioData_PerpEquityByDexUsdEntry: MessageFns<PortfolioData_PerpEquityByDexUsdEntry> =
  {
    encode(
      message: PortfolioData_PerpEquityByDexUsdEntry,
      writer: BinaryWriter = new BinaryWriter()
    ): BinaryWriter {
      if (message.key !== '') {
        writer.uint32(10).string(message.key)
      }
      if (message.value !== '') {
        writer.uint32(18).string(message.value)
      }
      return writer
    },

    decode(
      input: BinaryReader | Uint8Array,
      length?: number
    ): PortfolioData_PerpEquityByDexUsdEntry {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
      const end = length === undefined ? reader.len : reader.pos + length
      const message = createBasePortfolioData_PerpEquityByDexUsdEntry()
      while (reader.pos < end) {
        const tag = reader.uint32()
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break
            }

            message.key = reader.string()
            continue
          }
          case 2: {
            if (tag !== 18) {
              break
            }

            message.value = reader.string()
            continue
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break
        }
        reader.skip(tag & 7)
      }
      return message
    },

    fromJSON(object: any): PortfolioData_PerpEquityByDexUsdEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : '',
        value: isSet(object.value) ? globalThis.String(object.value) : '',
      }
    },

    toJSON(message: PortfolioData_PerpEquityByDexUsdEntry): unknown {
      const obj: any = {}
      if (message.key !== '') {
        obj.key = message.key
      }
      if (message.value !== '') {
        obj.value = message.value
      }
      return obj
    },

    create<I extends Exact<DeepPartial<PortfolioData_PerpEquityByDexUsdEntry>, I>>(
      base?: I
    ): PortfolioData_PerpEquityByDexUsdEntry {
      return PortfolioData_PerpEquityByDexUsdEntry.fromPartial(base ?? ({} as any))
    },
    fromPartial<I extends Exact<DeepPartial<PortfolioData_PerpEquityByDexUsdEntry>, I>>(
      object: I
    ): PortfolioData_PerpEquityByDexUsdEntry {
      const message = createBasePortfolioData_PerpEquityByDexUsdEntry()
      message.key = object.key ?? ''
      message.value = object.value ?? ''
      return message
    },
  }

function createBasePortfolioData_InitialMarginByPoolUsdEntry(): PortfolioData_InitialMarginByPoolUsdEntry {
  return { key: '', value: '' }
}

export const PortfolioData_InitialMarginByPoolUsdEntry: MessageFns<PortfolioData_InitialMarginByPoolUsdEntry> =
  {
    encode(
      message: PortfolioData_InitialMarginByPoolUsdEntry,
      writer: BinaryWriter = new BinaryWriter()
    ): BinaryWriter {
      if (message.key !== '') {
        writer.uint32(10).string(message.key)
      }
      if (message.value !== '') {
        writer.uint32(18).string(message.value)
      }
      return writer
    },

    decode(
      input: BinaryReader | Uint8Array,
      length?: number
    ): PortfolioData_InitialMarginByPoolUsdEntry {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
      const end = length === undefined ? reader.len : reader.pos + length
      const message = createBasePortfolioData_InitialMarginByPoolUsdEntry()
      while (reader.pos < end) {
        const tag = reader.uint32()
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break
            }

            message.key = reader.string()
            continue
          }
          case 2: {
            if (tag !== 18) {
              break
            }

            message.value = reader.string()
            continue
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break
        }
        reader.skip(tag & 7)
      }
      return message
    },

    fromJSON(object: any): PortfolioData_InitialMarginByPoolUsdEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : '',
        value: isSet(object.value) ? globalThis.String(object.value) : '',
      }
    },

    toJSON(message: PortfolioData_InitialMarginByPoolUsdEntry): unknown {
      const obj: any = {}
      if (message.key !== '') {
        obj.key = message.key
      }
      if (message.value !== '') {
        obj.value = message.value
      }
      return obj
    },

    create<I extends Exact<DeepPartial<PortfolioData_InitialMarginByPoolUsdEntry>, I>>(
      base?: I
    ): PortfolioData_InitialMarginByPoolUsdEntry {
      return PortfolioData_InitialMarginByPoolUsdEntry.fromPartial(base ?? ({} as any))
    },
    fromPartial<I extends Exact<DeepPartial<PortfolioData_InitialMarginByPoolUsdEntry>, I>>(
      object: I
    ): PortfolioData_InitialMarginByPoolUsdEntry {
      const message = createBasePortfolioData_InitialMarginByPoolUsdEntry()
      message.key = object.key ?? ''
      message.value = object.value ?? ''
      return message
    },
  }

function createBasePortfolioDataList(): PortfolioDataList {
  return { portfolioData: [] }
}

export const PortfolioDataList: MessageFns<PortfolioDataList> = {
  encode(message: PortfolioDataList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.portfolioData) {
      PortfolioData.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortfolioDataList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePortfolioDataList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.portfolioData.push(PortfolioData.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PortfolioDataList {
    return {
      portfolioData: globalThis.Array.isArray(object?.portfolioData)
        ? object.portfolioData.map((e: any) => PortfolioData.fromJSON(e))
        : globalThis.Array.isArray(object?.portfolio_data)
          ? object.portfolio_data.map((e: any) => PortfolioData.fromJSON(e))
          : [],
    }
  },

  toJSON(message: PortfolioDataList): unknown {
    const obj: any = {}
    if (message.portfolioData?.length) {
      obj.portfolioData = message.portfolioData.map((e) => PortfolioData.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PortfolioDataList>, I>>(base?: I): PortfolioDataList {
    return PortfolioDataList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PortfolioDataList>, I>>(object: I): PortfolioDataList {
    const message = createBasePortfolioDataList()
    message.portfolioData = object.portfolioData?.map((e) => PortfolioData.fromPartial(e)) || []
    return message
  },
}

function createBaseFeeTier(): FeeTier {
  return {
    instrumentType: '',
    symbol: undefined,
    makerFee: '',
    takerFee: '',
    feeType: undefined,
    blockTradeFee: undefined,
    baseCoin: undefined,
  }
}

export const FeeTier: MessageFns<FeeTier> = {
  encode(message: FeeTier, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.instrumentType !== '') {
      writer.uint32(10).string(message.instrumentType)
    }
    if (message.symbol !== undefined) {
      writer.uint32(18).string(message.symbol)
    }
    if (message.makerFee !== '') {
      writer.uint32(26).string(message.makerFee)
    }
    if (message.takerFee !== '') {
      writer.uint32(34).string(message.takerFee)
    }
    if (message.feeType !== undefined) {
      writer.uint32(42).string(message.feeType)
    }
    if (message.blockTradeFee !== undefined) {
      writer.uint32(50).string(message.blockTradeFee)
    }
    if (message.baseCoin !== undefined) {
      writer.uint32(58).string(message.baseCoin)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FeeTier {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseFeeTier()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.instrumentType = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.makerFee = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.takerFee = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.feeType = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.blockTradeFee = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.baseCoin = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): FeeTier {
    return {
      instrumentType: isSet(object.instrumentType)
        ? globalThis.String(object.instrumentType)
        : isSet(object.instrument_type)
          ? globalThis.String(object.instrument_type)
          : '',
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : undefined,
      makerFee: isSet(object.makerFee)
        ? globalThis.String(object.makerFee)
        : isSet(object.maker_fee)
          ? globalThis.String(object.maker_fee)
          : '',
      takerFee: isSet(object.takerFee)
        ? globalThis.String(object.takerFee)
        : isSet(object.taker_fee)
          ? globalThis.String(object.taker_fee)
          : '',
      feeType: isSet(object.feeType)
        ? globalThis.String(object.feeType)
        : isSet(object.fee_type)
          ? globalThis.String(object.fee_type)
          : undefined,
      blockTradeFee: isSet(object.blockTradeFee)
        ? globalThis.String(object.blockTradeFee)
        : isSet(object.block_trade_fee)
          ? globalThis.String(object.block_trade_fee)
          : undefined,
      baseCoin: isSet(object.baseCoin)
        ? globalThis.String(object.baseCoin)
        : isSet(object.base_coin)
          ? globalThis.String(object.base_coin)
          : undefined,
    }
  },

  toJSON(message: FeeTier): unknown {
    const obj: any = {}
    if (message.instrumentType !== '') {
      obj.instrumentType = message.instrumentType
    }
    if (message.symbol !== undefined) {
      obj.symbol = message.symbol
    }
    if (message.makerFee !== '') {
      obj.makerFee = message.makerFee
    }
    if (message.takerFee !== '') {
      obj.takerFee = message.takerFee
    }
    if (message.feeType !== undefined) {
      obj.feeType = message.feeType
    }
    if (message.blockTradeFee !== undefined) {
      obj.blockTradeFee = message.blockTradeFee
    }
    if (message.baseCoin !== undefined) {
      obj.baseCoin = message.baseCoin
    }
    return obj
  },

  create<I extends Exact<DeepPartial<FeeTier>, I>>(base?: I): FeeTier {
    return FeeTier.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<FeeTier>, I>>(object: I): FeeTier {
    const message = createBaseFeeTier()
    message.instrumentType = object.instrumentType ?? ''
    message.symbol = object.symbol ?? undefined
    message.makerFee = object.makerFee ?? ''
    message.takerFee = object.takerFee ?? ''
    message.feeType = object.feeType ?? undefined
    message.blockTradeFee = object.blockTradeFee ?? undefined
    message.baseCoin = object.baseCoin ?? undefined
    return message
  },
}

function createBaseAccountFees(): AccountFees {
  return { accountId: '', tradeVenue: 0, feeGroup: undefined, tiers: [], timestamp: '0' }
}

export const AccountFees: MessageFns<AccountFees> = {
  encode(message: AccountFees, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(16).int32(message.tradeVenue)
    }
    if (message.feeGroup !== undefined) {
      writer.uint32(26).string(message.feeGroup)
    }
    for (const v of message.tiers) {
      FeeTier.encode(v!, writer.uint32(34).fork()).join()
    }
    if (message.timestamp !== '0') {
      writer.uint32(40).int64(message.timestamp)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccountFees {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAccountFees()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.feeGroup = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.tiers.push(FeeTier.decode(reader, reader.uint32()))
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.timestamp = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AccountFees {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      feeGroup: isSet(object.feeGroup)
        ? globalThis.String(object.feeGroup)
        : isSet(object.fee_group)
          ? globalThis.String(object.fee_group)
          : undefined,
      tiers: globalThis.Array.isArray(object?.tiers)
        ? object.tiers.map((e: any) => FeeTier.fromJSON(e))
        : [],
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '0',
    }
  },

  toJSON(message: AccountFees): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.feeGroup !== undefined) {
      obj.feeGroup = message.feeGroup
    }
    if (message.tiers?.length) {
      obj.tiers = message.tiers.map((e) => FeeTier.toJSON(e))
    }
    if (message.timestamp !== '0') {
      obj.timestamp = message.timestamp
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AccountFees>, I>>(base?: I): AccountFees {
    return AccountFees.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AccountFees>, I>>(object: I): AccountFees {
    const message = createBaseAccountFees()
    message.accountId = object.accountId ?? ''
    message.tradeVenue = object.tradeVenue ?? 0
    message.feeGroup = object.feeGroup ?? undefined
    message.tiers = object.tiers?.map((e) => FeeTier.fromPartial(e)) || []
    message.timestamp = object.timestamp ?? '0'
    return message
  },
}

function createBaseAccountFeesList(): AccountFeesList {
  return { accountFees: [] }
}

export const AccountFeesList: MessageFns<AccountFeesList> = {
  encode(message: AccountFeesList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.accountFees) {
      AccountFees.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccountFeesList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAccountFeesList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountFees.push(AccountFees.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AccountFeesList {
    return {
      accountFees: globalThis.Array.isArray(object?.accountFees)
        ? object.accountFees.map((e: any) => AccountFees.fromJSON(e))
        : globalThis.Array.isArray(object?.account_fees)
          ? object.account_fees.map((e: any) => AccountFees.fromJSON(e))
          : [],
    }
  },

  toJSON(message: AccountFeesList): unknown {
    const obj: any = {}
    if (message.accountFees?.length) {
      obj.accountFees = message.accountFees.map((e) => AccountFees.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AccountFeesList>, I>>(base?: I): AccountFeesList {
    return AccountFeesList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AccountFeesList>, I>>(object: I): AccountFeesList {
    const message = createBaseAccountFeesList()
    message.accountFees = object.accountFees?.map((e) => AccountFees.fromPartial(e)) || []
    return message
  },
}

function createBaseAccountSummary(): AccountSummary {
  return {
    accountId: '',
    tradeVenue: 0,
    equityUsd: '',
    grossNotionalUsd: '',
    netNotionalUsd: '',
    grossLeverage: '',
    netLeverage: '',
    unrealizedPnlUsd: '',
    realizedPnlUsd: '',
    dailyUnrealizedPnlUsd: '',
    timestamp: '0',
    pnl1dUsd: undefined,
    pnl1wUsd: undefined,
    pnl1mUsd: undefined,
    pnlAllUsd: undefined,
    marginModelLabel: undefined,
    marginScope: 0,
    marginMethod: 0,
  }
}

export const AccountSummary: MessageFns<AccountSummary> = {
  encode(message: AccountSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(16).int32(message.tradeVenue)
    }
    if (message.equityUsd !== '') {
      writer.uint32(26).string(message.equityUsd)
    }
    if (message.grossNotionalUsd !== '') {
      writer.uint32(34).string(message.grossNotionalUsd)
    }
    if (message.netNotionalUsd !== '') {
      writer.uint32(42).string(message.netNotionalUsd)
    }
    if (message.grossLeverage !== '') {
      writer.uint32(50).string(message.grossLeverage)
    }
    if (message.netLeverage !== '') {
      writer.uint32(58).string(message.netLeverage)
    }
    if (message.unrealizedPnlUsd !== '') {
      writer.uint32(66).string(message.unrealizedPnlUsd)
    }
    if (message.realizedPnlUsd !== '') {
      writer.uint32(74).string(message.realizedPnlUsd)
    }
    if (message.dailyUnrealizedPnlUsd !== '') {
      writer.uint32(82).string(message.dailyUnrealizedPnlUsd)
    }
    if (message.timestamp !== '0') {
      writer.uint32(88).int64(message.timestamp)
    }
    if (message.pnl1dUsd !== undefined) {
      writer.uint32(98).string(message.pnl1dUsd)
    }
    if (message.pnl1wUsd !== undefined) {
      writer.uint32(106).string(message.pnl1wUsd)
    }
    if (message.pnl1mUsd !== undefined) {
      writer.uint32(114).string(message.pnl1mUsd)
    }
    if (message.pnlAllUsd !== undefined) {
      writer.uint32(122).string(message.pnlAllUsd)
    }
    if (message.marginModelLabel !== undefined) {
      writer.uint32(130).string(message.marginModelLabel)
    }
    if (message.marginScope !== 0) {
      writer.uint32(136).int32(message.marginScope)
    }
    if (message.marginMethod !== 0) {
      writer.uint32(144).int32(message.marginMethod)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccountSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAccountSummary()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.equityUsd = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.grossNotionalUsd = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.netNotionalUsd = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.grossLeverage = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.netLeverage = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.unrealizedPnlUsd = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.realizedPnlUsd = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.dailyUnrealizedPnlUsd = reader.string()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.timestamp = reader.int64().toString()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.pnl1dUsd = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.pnl1wUsd = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.pnl1mUsd = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.pnlAllUsd = reader.string()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.marginModelLabel = reader.string()
          continue
        }
        case 17: {
          if (tag !== 136) {
            break
          }

          message.marginScope = reader.int32() as any
          continue
        }
        case 18: {
          if (tag !== 144) {
            break
          }

          message.marginMethod = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AccountSummary {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      equityUsd: isSet(object.equityUsd)
        ? globalThis.String(object.equityUsd)
        : isSet(object.equity_usd)
          ? globalThis.String(object.equity_usd)
          : '',
      grossNotionalUsd: isSet(object.grossNotionalUsd)
        ? globalThis.String(object.grossNotionalUsd)
        : isSet(object.gross_notional_usd)
          ? globalThis.String(object.gross_notional_usd)
          : '',
      netNotionalUsd: isSet(object.netNotionalUsd)
        ? globalThis.String(object.netNotionalUsd)
        : isSet(object.net_notional_usd)
          ? globalThis.String(object.net_notional_usd)
          : '',
      grossLeverage: isSet(object.grossLeverage)
        ? globalThis.String(object.grossLeverage)
        : isSet(object.gross_leverage)
          ? globalThis.String(object.gross_leverage)
          : '',
      netLeverage: isSet(object.netLeverage)
        ? globalThis.String(object.netLeverage)
        : isSet(object.net_leverage)
          ? globalThis.String(object.net_leverage)
          : '',
      unrealizedPnlUsd: isSet(object.unrealizedPnlUsd)
        ? globalThis.String(object.unrealizedPnlUsd)
        : isSet(object.unrealized_pnl_usd)
          ? globalThis.String(object.unrealized_pnl_usd)
          : '',
      realizedPnlUsd: isSet(object.realizedPnlUsd)
        ? globalThis.String(object.realizedPnlUsd)
        : isSet(object.realized_pnl_usd)
          ? globalThis.String(object.realized_pnl_usd)
          : '',
      dailyUnrealizedPnlUsd: isSet(object.dailyUnrealizedPnlUsd)
        ? globalThis.String(object.dailyUnrealizedPnlUsd)
        : isSet(object.daily_unrealized_pnl_usd)
          ? globalThis.String(object.daily_unrealized_pnl_usd)
          : '',
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '0',
      pnl1dUsd: isSet(object.pnl1dUsd)
        ? globalThis.String(object.pnl1dUsd)
        : isSet(object.pnl_1d_usd)
          ? globalThis.String(object.pnl_1d_usd)
          : undefined,
      pnl1wUsd: isSet(object.pnl1wUsd)
        ? globalThis.String(object.pnl1wUsd)
        : isSet(object.pnl_1w_usd)
          ? globalThis.String(object.pnl_1w_usd)
          : undefined,
      pnl1mUsd: isSet(object.pnl1mUsd)
        ? globalThis.String(object.pnl1mUsd)
        : isSet(object.pnl_1m_usd)
          ? globalThis.String(object.pnl_1m_usd)
          : undefined,
      pnlAllUsd: isSet(object.pnlAllUsd)
        ? globalThis.String(object.pnlAllUsd)
        : isSet(object.pnl_all_usd)
          ? globalThis.String(object.pnl_all_usd)
          : undefined,
      marginModelLabel: isSet(object.marginModelLabel)
        ? globalThis.String(object.marginModelLabel)
        : isSet(object.margin_model_label)
          ? globalThis.String(object.margin_model_label)
          : undefined,
      marginScope: isSet(object.marginScope)
        ? marginScopeFromJSON(object.marginScope)
        : isSet(object.margin_scope)
          ? marginScopeFromJSON(object.margin_scope)
          : 0,
      marginMethod: isSet(object.marginMethod)
        ? marginMethodFromJSON(object.marginMethod)
        : isSet(object.margin_method)
          ? marginMethodFromJSON(object.margin_method)
          : 0,
    }
  },

  toJSON(message: AccountSummary): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.equityUsd !== '') {
      obj.equityUsd = message.equityUsd
    }
    if (message.grossNotionalUsd !== '') {
      obj.grossNotionalUsd = message.grossNotionalUsd
    }
    if (message.netNotionalUsd !== '') {
      obj.netNotionalUsd = message.netNotionalUsd
    }
    if (message.grossLeverage !== '') {
      obj.grossLeverage = message.grossLeverage
    }
    if (message.netLeverage !== '') {
      obj.netLeverage = message.netLeverage
    }
    if (message.unrealizedPnlUsd !== '') {
      obj.unrealizedPnlUsd = message.unrealizedPnlUsd
    }
    if (message.realizedPnlUsd !== '') {
      obj.realizedPnlUsd = message.realizedPnlUsd
    }
    if (message.dailyUnrealizedPnlUsd !== '') {
      obj.dailyUnrealizedPnlUsd = message.dailyUnrealizedPnlUsd
    }
    if (message.timestamp !== '0') {
      obj.timestamp = message.timestamp
    }
    if (message.pnl1dUsd !== undefined) {
      obj.pnl1dUsd = message.pnl1dUsd
    }
    if (message.pnl1wUsd !== undefined) {
      obj.pnl1wUsd = message.pnl1wUsd
    }
    if (message.pnl1mUsd !== undefined) {
      obj.pnl1mUsd = message.pnl1mUsd
    }
    if (message.pnlAllUsd !== undefined) {
      obj.pnlAllUsd = message.pnlAllUsd
    }
    if (message.marginModelLabel !== undefined) {
      obj.marginModelLabel = message.marginModelLabel
    }
    if (message.marginScope !== 0) {
      obj.marginScope = marginScopeToJSON(message.marginScope)
    }
    if (message.marginMethod !== 0) {
      obj.marginMethod = marginMethodToJSON(message.marginMethod)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AccountSummary>, I>>(base?: I): AccountSummary {
    return AccountSummary.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AccountSummary>, I>>(object: I): AccountSummary {
    const message = createBaseAccountSummary()
    message.accountId = object.accountId ?? ''
    message.tradeVenue = object.tradeVenue ?? 0
    message.equityUsd = object.equityUsd ?? ''
    message.grossNotionalUsd = object.grossNotionalUsd ?? ''
    message.netNotionalUsd = object.netNotionalUsd ?? ''
    message.grossLeverage = object.grossLeverage ?? ''
    message.netLeverage = object.netLeverage ?? ''
    message.unrealizedPnlUsd = object.unrealizedPnlUsd ?? ''
    message.realizedPnlUsd = object.realizedPnlUsd ?? ''
    message.dailyUnrealizedPnlUsd = object.dailyUnrealizedPnlUsd ?? ''
    message.timestamp = object.timestamp ?? '0'
    message.pnl1dUsd = object.pnl1dUsd ?? undefined
    message.pnl1wUsd = object.pnl1wUsd ?? undefined
    message.pnl1mUsd = object.pnl1mUsd ?? undefined
    message.pnlAllUsd = object.pnlAllUsd ?? undefined
    message.marginModelLabel = object.marginModelLabel ?? undefined
    message.marginScope = object.marginScope ?? 0
    message.marginMethod = object.marginMethod ?? 0
    return message
  },
}

function createBaseAccountSummaryList(): AccountSummaryList {
  return { accountSummary: [] }
}

export const AccountSummaryList: MessageFns<AccountSummaryList> = {
  encode(message: AccountSummaryList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.accountSummary) {
      AccountSummary.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AccountSummaryList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAccountSummaryList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountSummary.push(AccountSummary.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AccountSummaryList {
    return {
      accountSummary: globalThis.Array.isArray(object?.accountSummary)
        ? object.accountSummary.map((e: any) => AccountSummary.fromJSON(e))
        : globalThis.Array.isArray(object?.account_summary)
          ? object.account_summary.map((e: any) => AccountSummary.fromJSON(e))
          : [],
    }
  },

  toJSON(message: AccountSummaryList): unknown {
    const obj: any = {}
    if (message.accountSummary?.length) {
      obj.accountSummary = message.accountSummary.map((e) => AccountSummary.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AccountSummaryList>, I>>(base?: I): AccountSummaryList {
    return AccountSummaryList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AccountSummaryList>, I>>(object: I): AccountSummaryList {
    const message = createBaseAccountSummaryList()
    message.accountSummary = object.accountSummary?.map((e) => AccountSummary.fromPartial(e)) || []
    return message
  },
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
    ? globalThis.Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
      ? ReadonlyArray<DeepPartial<U>>
      : T extends {}
        ? { [K in keyof T]?: DeepPartial<T[K]> }
        : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never }

function isObject(value: any): boolean {
  return typeof value === 'object' && value !== null
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter
  decode(input: BinaryReader | Uint8Array, length?: number): T
  fromJSON(object: any): T
  toJSON(message: T): unknown
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T
}
